import React from 'react'
// Components
import Sports from 'components/Sports/__Sports'
import Tournaments from 'components/Tournament/__Tournament'
import Stages from 'components/Stages/__Stages'
import Round from 'components/Rounds/__Rounds'
import Matches from 'components/Matches/__Matches'
import MatchMaps from 'components/MatchMaps/__MatchMaps'
import MatchMapVetos from 'components/MatchMapVetos/__MatchMapVetos'
import Team from 'components/Team/__Team'
import Sportsmen from 'components/Sportsmen/__Sportsmen'
import Players from 'components/Player/__Players'
import SportsmanRanks from 'components/SportsmanRanks/__SportsmanRanks'
import SportsmanTeamMemberhips from 'components/SportsmanTeamMemberships/__SportsmanTeamMemberships'
import TeamRanks from 'components/TeamRanks/__TeamRanks'
import SportsmanStats from 'components/SportsmanStatSummary/__SportsmanStatSummaries'
import TeamStats from 'components/TeamStatSummary/__TeamStatSummaries'
import NearestMatch from 'components/NearestMatches/__NearestMatches'
import GamingGear from 'components/GamingGears/__GamingGears'
import TeamOrganization from 'components/TeamOrganizations/__TeamOrganizations'
// Additional
import { Tab } from 'static/tabs'
import { Routing } from 'helpers/routing'
import TeamDatasourceIdentifier from 'components/TeamDatasourceIdentifiers/__TeamDatasourceIdentifiers'
import { SportsmanDatasourceIdentifierContext } from 'components/SportsmanDatasourceIdentifiers/SportmsanDatasourceIdentifiers.context'
import SportsmanDatasourceIdentifier from 'components/SportsmanDatasourceIdentifiers/__SportsmanDatasourceIdentifiers'
import TournamentDatasourceIdentifier from 'components/TournamentDatasourceIdentifiers/__TournamentDatasourceIdentifiers'
import TeamOrganizationDatasourceIdentifier from 'components/TeamOrganizationDatasourceIdentifiers/__TeamOrganizationDatasourceIdentifiers'
import MatchDatasourceIdentifier from 'components/MatchDatasourceIdentifiers/__MatchDatasourceIdentifier'


export module TabMapper {
  export interface RouteProps {
    readonly node: React.ReactNode
    readonly isExact?: boolean
  }

  export interface Node {
    readonly nodes?: { [id: string]: Node }

    readonly routes?: { [id: string]: RouteProps }

    readonly disableTabRender?: boolean
    readonly overrideText?: string
  }

  export const Settings: { [id: string]: Node } = {
    [Tab.Sports]: {
      routes: {
        [Routing.getSportSelectPath()]: {
          node: <Sports phase={'select'} />,
          isExact: true,
        },
        [Routing.getDefaultPath()]: {
          node: <Sports phase={'select'} />,
          isExact: true,
        },

        [Routing.getSportDetailPath()]: {
          node: <Sports phase={'detail'} />,
        },
      },
      nodes: {
        [Tab.Teams]: {
          routes: {
            [Routing.getTeamSelectPath()]: {
              node: <Team phase={'select'} />,
              isExact: true,
            },
            [Routing.getTeamDetailPath()]: {
              node: <Team phase={'detail'} />,
            },
          },
          nodes: {
            [Tab.TeamDatasourceIdentifiers]: {
              routes: {
                [Routing.getTeamDatasourceIdentifierSelectPath()]: {
                  node: <TeamDatasourceIdentifier phase={'select'} />,
                },
                [Routing.getTeamDatasourceIdentifierDetailPath()]: {
                  node: <TeamDatasourceIdentifier phase={'detail'} />,
                },
              },
              disableTabRender: true,
            }
          }
        },
        [Tab.TeamOrganizations]: {
          routes: {
            [Routing.getTeamOrganizationSelectPath()]: {
              node: <TeamOrganization phase={'select'} />,
              isExact: true,
            },
            [Routing.getTeamOrganizationDetailPath()]: {
              node: <TeamOrganization phase={'detail'} />,
            },
          },
          nodes: {
            [Tab.TeamOrganizatonDatasourceIdentifiers]: {
              routes: {
                [Routing.getTeamOrganizationDatasourceIdentifierDetailPath()]: {
                  node: <TeamOrganizationDatasourceIdentifier phase={'detail'} />
                },
              },
              disableTabRender: true,
            }
          }
        },
        [Tab.Sportsmen]: {
          routes: {
            [Routing.getSportsmanSelectPath()]: {
              node: <Sportsmen phase={'select'} />,
              isExact: true,
            },
            [Routing.getSportsmanDetailPath()]: {
              node: <Sportsmen phase={'detail'} />,
            },
          },
          nodes: {
            [Tab.SportsmanTeamMemberships]: {
              routes: {
                [Routing.getSportsmanTeamMembershipDetailPathFromTeam()]: {
                  node: <SportsmanTeamMemberhips phase={'detail'} />,
                },
                [Routing.getSportsmanTeamMembershipDetailPathFromSportsman()]: {
                  node: <SportsmanTeamMemberhips phase={'detail'} />,
                },
              },
              disableTabRender: true,
            },
            [Tab.SportsmanDatasourceIdentifiers]: {
              routes: {
                [Routing.getSportsmanDatasourceIdentifierDetailPath()]: {
                  node: <SportsmanDatasourceIdentifier phase={'detail'} />
                }
              },
              disableTabRender: true,
            }
          },
        }
      }
    },
    [Tab.Tournaments]: {
      routes: {
        [Routing.getTournamentSelectPath()]: {
          node: <Tournaments phase={'select'} />,
          isExact: true,
        },
        [Routing.getTournamentDetailPath()]: {
          node: <Tournaments phase={'detail'} />,
        },
      },
      nodes: {
        [Tab.TournamentDatasourceIdentifiers]: {
          routes: {
            [Routing.getTournamentDatasourceIdentifiersDetailPath()]: {
              node: <TournamentDatasourceIdentifier phase={'detail'} />
            }
          },
          disableTabRender: true,
        },
        [Tab.Stages]: {
          routes: {
            [Routing.getStageSelectPath()]: {
              node: <Stages phase={'select'} />,
              isExact: true,
            },
            [Routing.getStageDetailPath()]: {
              node: <Stages phase={'detail'} />,
            },
          },
          disableTabRender: true,
        },
        [Tab.Rounds]: {
          routes: {
            [Routing.getRoundSelectPath()]: {
              node: <Round phase={'select'} />,
              isExact: true,
            },
            [Routing.getRoundDetailPath()]: {
              node: <Round phase={'detail'} />,
            },
          },
          disableTabRender: true,
        },
        [Tab.Matches]: {
          routes: {
            [Routing.getMatchSelectPath()]: {
              node: <Matches phase={'select'} />,
              isExact: true,
            },
            [Routing.getMatchDetailPath()]: {
              node: <Matches phase={'detail'} />,
            },
          },

          nodes: {
            [Tab.MatchMaps]: {
              routes: {
                [Routing.getMatchMapDetailPath()]: {
                  node: <MatchMaps phase={'detail'} />,
                },
              },
              disableTabRender: true,
            },
            [Tab.MatchMapVetos]: {
              routes: {
                [Routing.getMatchMapVetoDetailPath()]: {
                  node: <MatchMapVetos phase={'detail'} />,
                },
              },
              disableTabRender: true,
            },
            [Tab.Players]: {
              routes: {
                [Routing.getPlayerDetailPath()]: {
                  node: <Players phase={'detail'} />,
                },
              },
              disableTabRender: true,
            },
          },
          disableTabRender: true,
        },
      },
    },
    [Tab.NearestMatches]:{
      routes: {
        [Routing.getNearestMatchSelectPath()]: {
          node: <NearestMatch phase={'select'} />,
          isExact: true,
        },
      },
      nodes: {
        [Tab.MatchDatasourceIdentifiers]: {
          routes: {
            [Routing.getMatchDatasourceIdentifierDetailPath()]: {
              node: <MatchDatasourceIdentifier phase={'detail'} />
            },
          },
          disableTabRender: true,
        }
      }
    },
    [Tab.GammingGears]: {
      routes: {
        [Routing.getGamingGearSelectPath()]: {
          node: <GamingGear phase={'select'} />,
          isExact: true,
        },
        [Routing.getGamingGearDetailPath()]: {
          node: <GamingGear phase={'detail'} />,
        },
      },
      disableTabRender: true,
    },
    [Tab.TeamStats]: {
      routes: {
        [Routing.getTeamStatSelectPath()]: {
          node: <TeamStats phase={'select'} />,
          isExact: true,
        },
      },
      disableTabRender: true,
    },
    [Tab.TeamRanks]: {
      routes: {
        [Routing.getTeamRankSelectPath()]: {
          node: <TeamRanks phase={'select'} />,
          isExact: true,
        },
        [Routing.getTeamRankDetailPath()]: {
          node: <TeamRanks phase={'detail'} />,
        },
      },
      disableTabRender: true,
    },
    [Tab.SportsmanStats]: {
      routes: {
        [Routing.getSportsmanStatSelectPath()]: {
          node: <SportsmanStats phase={'select'} />,
          isExact: true,
        },
      },
      disableTabRender: true,
    },
    [Tab.SportsmanRanks]: {
      routes: {
        [Routing.getSportsmanRankSelectPath()]: {
          node: <SportsmanRanks phase={'select'} />,
          isExact: true,
        },
        [Routing.getSportsmanRankDetailPath()]: {
          node: <SportsmanRanks phase={'detail'} />,
        },
      },
      disableTabRender: true,
    },
  }
}
